import ResourceLoaderProto from "../../core/core3-depricated/app/resource-loader-proto";

const appLoaderFunction = () => import(/* webpackChunkName: "ai-chat" */ './app')

export default class AppLoader_AIChat extends ResourceLoaderProto {


    constructor(appParams:any) {
        super(appParams);
    }

    resources() {
        return [
            this._loadCSS('app-ai-chat'),
            this._loadAPP(appLoaderFunction)
        ];
    }
}

